import {http} from "./http";
import { getPaginationRequestParams } from "../utils/paginationRequest";

export function getGroups(pagination) {
    return http.get(`v1/groups?${getPaginationRequestParams(pagination)}`);
}

export function deleteGroup (id) {
    return http.delete(`v1/groups/${id}`);
}

export function createGroup (group) {
    return http.post(`v1/groups`, {...group});
}

export function updateGroup (group, id) {
    return http.patch(`v1/groups/${id}`, {...group});
}

export function getGroup (id) {
    return http.get(`v1/groups/${id}`);
}

export function getGroupChildrenByName(region) {
    //'http://localhost:5000/v1/groups/Lombardiapp/children' \
    return http.get(`v1/groups/${region}/children`);
}

export function getGroupChildrenByMunicipality(municipalityId) {
    return http.get(`v1/groups/by-municipality/${municipalityId}/children`);
}

export function paginateGroupByUser(pagination) {
    return http.get(`v1/groups/paginate/user?${getPaginationRequestParams(pagination)}`);
}

export function getGroupParent(id) {
    return http.get(`v1/groups/${id}/parent`);
}

export function adoptCircles(id, groupIds) {
    return http.post(`v1/groups/${id}/adopt-circles`, { groupIds });
}

export function getGroupTree(parentId) {
    const params = new URLSearchParams();

    if (parentId) {
        params.append("parentId", parentId);
    }

    const qs = params.toString();

    return http.get(`v1/groups/tree${qs ? `?${qs}` : ""}`);
}

export function getPossibleParents(id, searchText) {
    const urlParams = new URLSearchParams();

    if (searchText) {
        urlParams.append("search", searchText);
    }

    return http.get(`v1/groups/${id}/possible-parents?${urlParams}`);
}